import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
// react-router-dom
import { Outlet, useLocation, useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useSetRecoilState } from "recoil";
// atoms
import { fillFormStatusAtom, userAtom } from "src/recoil";
// hooks
import useToaster from "src/hooks/useToaster";
// __apis__
import { fetchUser } from "src/__apis__/user";
import { checkFormFillStatusRequest } from "src/__apis__/algorithmForm";
// layouts
import DashboardLayout from "./DashboardLayout";
import AuthLayout from "./AuthLayout";
import { PATH_AUTH } from "src/routes/paths";

// --------------------------------------------------------------------------

function LayoutGenerator({ children }) {
  const [isAuth, setIsAuth] = useState(false);

  const [user, setUser] = useRecoilState(userAtom);

  const [fetchingUser, setIsFetchingUser] = useState(false);

  const { triggerToast } = useToaster();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const setFillFormStatus = useSetRecoilState(fillFormStatusAtom);

  const userFetcher = useCallback(async () => {
    setIsFetchingUser(true);
    await fetchUser()
      .then((response) => {
        console.log("user response", response);

        setUser(response);
        setIsFetchingUser(false);
      })
      .catch((error) => {
        triggerToast(
          "error",
          "Failed Loading Profile Please Contact Support Or Refresh The Page."
        );
      });
  }, [setUser, triggerToast, setIsFetchingUser]);

  const checkFormFillStatus = useCallback(async () => {
    checkFormFillStatusRequest()
      .then((response) => {
        console.log("form fill statys", response);

        setFillFormStatus(response);
      })
      .catch((error) => {
        triggerToast(
          "error",
          "Something Wrong Gone, Please Contact Support. Couldn't Load Form Status."
        );
      });
  }, []);

  useLayoutEffect(() => {
    if (localStorage.getItem("access_token")) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
      if (![PATH_AUTH.signIn, PATH_AUTH.signUp].includes(pathname)) {
        navigate(PATH_AUTH.signIn);
      }
    }
  }, [localStorage, pathname]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (localStorage.getItem("access_token")) {
        setIsAuth(true);
      } else {
        setIsAuth(false);
        navigate(PATH_AUTH.signIn);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [localStorage, setIsAuth]);

  useEffect(() => {
    if (isAuth && !user) {
      userFetcher();
      checkFormFillStatus();
    }
  }, [isAuth, user]);

  if (isAuth) {
    if ([PATH_AUTH.signIn, PATH_AUTH.signUp].includes(pathname)) {
      return (
        <AuthLayout>
          <Outlet />
        </AuthLayout>
      );
    }
    return <DashboardLayout>{children}</DashboardLayout>;
  } else {
    return (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    );
  }
}

export default LayoutGenerator;
